import { ClassUtils } from "../../utils/ClassUtils";
export class RoundedRectMesh {
    constructor() {
        this.lt = 6;
        this.rt = 6;
        this.lb = 6;
        this.rb = 6;
    }
    onPopulateMesh(vb) {
        let x = vb.contentRect.x;
        let y = vb.contentRect.y;
        let w = vb.contentRect.width;
        let h = vb.contentRect.height;
        let radiusX = w / 2;
        let radiusY = h / 2;
        let cornerMaxRadius = Math.min(radiusX, radiusY);
        let centerX = x + radiusX;
        let centerY = y + radiusY;
        vb.addVert(centerX, centerY);
        let cnt = vb.vertCount;
        for (let i = 0; i < 4; i++) {
            let radius = 0;
            switch (i) {
                case 0:
                    radius = this.rb;
                    break;
                case 1:
                    radius = this.lb;
                    break;
                case 2:
                    radius = this.lt;
                    break;
                case 3:
                    radius = this.rt;
                    break;
            }
            radius = Math.min(cornerMaxRadius, radius);
            let offsetX = 0;
            let offsetY = 0;
            if (i === 0 || i === 3)
                offsetX = w - radius * 2;
            if (i === 0 || i === 1)
                offsetY = h - radius * 2;
            offsetX += x;
            offsetY += y;
            if (radius !== 0) {
                let partNumSides = Math.max(1, Math.ceil(Math.PI * radius / 8)) + 1;
                let angleDelta = Math.PI / 2 / partNumSides;
                let angle = Math.PI / 2 * i;
                let startAngle = angle;
                for (let j = 1; j <= partNumSides; j++) {
                    if (j === partNumSides)
                        angle = startAngle + Math.PI / 2;
                    vb.addVert(offsetX + Math.cos(angle) * radius + radius, offsetY + Math.sin(angle) * radius + radius);
                    angle += angleDelta;
                }
            }
            else {
                vb.addVert(offsetX, offsetY);
            }
        }
        cnt = vb.vertCount - cnt;
        for (let i = 0; i < cnt; i++)
            vb.addTriangle(0, i + 1, i === cnt - 1 ? 1 : i + 2);
    }
}
ClassUtils.regClass("RoundedRectMesh", RoundedRectMesh);
